import { render } from "./Checkbox.vue?vue&type=template&id=63587001&scoped=true&ts=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=63587001&lang=scss&scoped=true"
import "./Checkbox.vue?vue&type=style&index=1&id=63587001&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63587001"]])

export default __exports__